import React, {useContext} from 'react'
import AppBar from "@material-ui/core/AppBar";
import {Button, IconButton, makeStyles, Menu, MenuItem, Toolbar, Typography} from '@material-ui/core';

import MenuIcon from '@material-ui/icons/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Group from '@material-ui/icons/Group';
import Home from '@material-ui/icons/Home';
import VolumeOff from '@material-ui/icons/VolumeOff';
import VolumeUp from '@material-ui/icons/VolumeUp';
import {AppContext} from "../AppContext";
import {useHistory} from "react-router-dom";
import {LocalPlay} from "@material-ui/icons";

export default function NavBar(props) {

    const context = useContext(AppContext)

    const useStyles = makeStyles((theme) => ({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        title: {
            flexGrow: 1,
        },
        userName: {
            flexGrow: 0,
        }
    }));
    const classes = useStyles();

    const history = useHistory();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const showProfile = () => {
        history.push("/profile")
        handleClose()
    }

    const handleLogout = () => {
        context.logout()
        handleClose()
    }

    if (context.currentUser) {
        return (
            <AppBar position="static">
                <Toolbar>
                    <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                        <MenuIcon/>
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        {props.currentEvent ? props.currentEvent.name : ""}
                    </Typography>
                    {context.currentUser && (
                        <>
                            <IconButton
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                onClick={() => history.push("/")}
                                color="inherit"
                            >
                                <Home/>
                            </IconButton>
                            <IconButton
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                onClick={() => history.push("/admin_home")}
                                color="inherit"
                            >
                                <LocalPlay/>
                            </IconButton>
                            {props.currentEvent && (
                                <>
                                    <IconButton
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        onClick={() => history.push(`/game/${props.currentEvent.id}`)}
                                        color="inherit"
                                    >
                                        <Group/>
                                    </IconButton>
                                    {/*<IconButton
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        onClick={() => context.setPageInState("game")}
                                        color="inherit"
                                    >
                                        <Group/>
                                    </IconButton>
                                    <IconButton
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        onClick={() => context.setPageInState("schedule")}
                                        color="inherit"
                                    >
                                        <Schedule/>
                                    </IconButton>*/}

                                </>
                            )}
                            <IconButton
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                onClick={context.toggleAudioActive}
                                color="inherit"
                            >
                                {context.audioActive ? (<VolumeUp/>) : (<VolumeOff/>)}
                            </IconButton>
                            <Typography variant="h6"
                                        className={classes.userName}>{context.currentUser.name}</Typography>
                            <IconButton
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                // onClick={handleMenu}
                                color="inherit"
                                onClick={handleClick}
                            >
                                <AccountCircle/>
                            </IconButton>
                            <Menu
                                id="simple-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={showProfile}>Profile</MenuItem>
                                <MenuItem onClick={handleLogout}>Logout</MenuItem>
                            </Menu>
                        </>
                    )}
                    {!context.currentUser && (
                        <Button color="inherit">Login</Button>
                    )}
                </Toolbar>
            </AppBar>
        )
    } else {
        return (<div className="navbar"/>)
    }
}
